export const selectIsLoggedIn = (state) => state.ui.auth.isLoggedIn;
export const selectTokenData = (state) => state.data.auth.tokenData;
export const selectUserData = (state) => state.data.auth.userData;
